import React, { Component } from 'react';

import PropTypes from 'prop-types';
import ClassNames from "classnames";

// import Advert from "@alife/ocms-fusion-1688-pc-cate1688-pc-widget";
// import AdvertBrandZone from "@alife/ocms-fusion-1688-pc-wb-1688-cbu-advert-brand-zone-pc";

import '@alife/ocms-fusion-1688-pc-wb-1688-cbu-advert-brand-zone-pc/index.scss'


class SEMAdvert extends Component {

  static propTypes = {
    width: PropTypes.number,
  }


  constructor(opts) {
    super(opts);
    this.renderTemplate = this.renderTemplate.bind(this);
  }


  componentWillMount() {
    //让iframe 高度为空
    window.addEventListener('message', (event) => {
      try {
        const { data } = event;
        if (data && data.type === "brandNodata") {
          document.getElementById('brand_iframe').style.display = "none";
        }
      } catch (e) {
          console.error(e);
      }

    })
  }



  renderTemplate() {
    //todo
    const { width } = this.props;
    const { keywordsGbk } = window.pageConfig;
    return <div><iframe id="brand_iframe" src={`//fn-tanx-src.1688.com/wapBrandTemplate?keywords=${keywordsGbk}&__input_charset=GBK&requestId=&pid=220127_0001&client=pc`} width={width} height="220" className="no-border" /></div>
  }

  render() {
    const { width } = this.props;
    const clswarp = ClassNames({
      "alibar-wrapper": true,
      "w_1190": width === 1190,
      "w_990": width === 990,
      "w_1390": width === 1390
    })
    return (<div className={clswarp}>
      {
        // window.pageConfig.brandInfo && window.pageConfig.brandInfo.templateId == 30105 ? (
        //   <AdvertBrandZone data={window.pageConfig.brandInfo} isSEM />
        // ) : (
        //   <Advert data={window.pageConfig.brandInfo} isSEM />
        //   )
        this.renderTemplate()
      }
    </div>)
  }
}

export default SEMAdvert;
